import React from 'react';
import { Flex } from '@chakra-ui/react';
import Header from './components/header';
import Footer from './components/footer';

export default function RootLayout({ children }) {
  return (
    <>
      <Header />
      <Flex
        as="main"
        backgroundColor="#F9F9F9"
        flexDirection="column"
        width="100%"
        minH="100vh"
      >
        {children}
      </Flex>
      <Footer />
    </>
  );
}
